import { FC } from 'react'
import { useField } from 'formik'
import { TextField, TextFieldProps } from '@mui/material'
import { createTheme, ThemeProvider } from '@mui/material/styles'
import theme from 'theme'

const muiTheme = createTheme({
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        input: {
          '&:-webkit-autofill': {
            '-webkit-background-clip': 'text !important',
            '-webkit-text-fill-color': theme.baseColors.greyscale[80]
          }
        }
      }
    }
  }
})

type Props = TextFieldProps & {
  name: string
}

const ControlledTextField: FC<Props> = ({ name, ...rest }) => {
  const [field] = useField(name)

  return (
    <ThemeProvider theme={muiTheme}>
      <TextField {...field} {...rest} />
    </ThemeProvider>
  )
}

export default ControlledTextField
